import React from "react";
import "./index.scss";
import data from "../../data/dummy-data/projects.json";

import ProjectItem from "../../Components/ProjectItem";

const Projects = function() {
  return (
    <div className="projects">
      <h1
        style={{
          textAlign: "center",
          padding: "1rem 0"
        }}
      >
        Proyectos
      </h1>
      {data.projects.map((project, index) => {
        return (
          <div className="projectItem__container" key={index}>
            <ProjectItem
              id={project.id}
              img={project.imageUrl}
              project={project}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Projects;
